module.exports = __webpack_public_path__ + "img/close-icon.533fbd74.svg";